import { useEffect } from 'react';
import { injectZigzagHandler, zigzagHandler } from '@croquiscom/web2app';

import { TabType } from '../constants/tab_menu';
import { getFocusTabUrl } from '../services/useActiveTabTypeAtom';

export const useSavedMyGoods = () => {
  useEffect(() => {
    injectZigzagHandler();
    zigzagHandler('onSavedMyGoods', (data) => {
      window.history.replaceState(null, '', getFocusTabUrl(data as TabType, false));
    });
  }, []);
};
